import * as React from "react";
import { cn } from "@/lib/studio/utils";

export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("loading-parallax rounded-md bg-muted", className)}
      {...props}
    />
  );
}
